import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref } from "vue"

const _hoisted_1 = { class: "d-flex align-items-start flex-column my-5" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h3", { class: "mb-4 fw-bold" }, "Sección exclusiva para usuarios registrados", -1)
const _hoisted_3 = { class: "mb-5" }
const _hoisted_4 = { class: "mb-5" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("p", null, " Si ya tenes una cuenta, podes iniciar sesión desde el siguiente botón ", -1)
const _hoisted_6 = { class: "mb-4" }
const _hoisted_7 = { class: "fw-bold" }
const _hoisted_8 = { class: "fw-bold" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createElementVNode("span", { class: "fw-bold" }, "RECORDÁ"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" Si ya cargaste la documentación de tu/s vehículo/s, estos deben pasar el proceso de verificacIón. Por lo general, este proceso se realiza de forma automática. En caso de que no tengamos tu información, este proceso puede verse demorado hasta que realicemos la verificación de la documentación. ")
], -1)
const _hoisted_10 = { class: "fw-bold" }
const _hoisted_11 = { class: "mb-4" }
const _hoisted_12 = { class: "fw-bold" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("p", null, " Inicia sesión o registrate a continuación para acceder a beneficios exclusivos. ", -1)


import { useStore } from 'vuex'
import { VuexStore } from '@/interfaces/VuexStore'
import { key } from '@/setup/store'
import state from '@/store/state'


export default /*#__PURE__*/_defineComponent({
  __name: 'VMensajeExclusividad',
  props: {
    nombreEvento: null,
    marca: null,
    soloRegistrados: { type: Boolean },
    soloFidelizados: { type: Boolean }
  },
  setup(__props: any) {

const props = __props as {
  nombreEvento: string
  marca: string
  soloRegistrados?: boolean
  soloFidelizados?: boolean
};

const { getters } = useStore<VuexStore>(key)



return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (props.soloRegistrados && !props.soloFidelizados)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          _hoisted_2,
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("p", null, " Para continuar es necesario que generes una cuenta de usuario en " + _toDisplayString(props.nombreEvento) + ". ", 1),
            _createVNode(_component_router_link, {
              to: { name: 'Register' },
              class: "btn btn-primary px-4 py-2",
              tag: "button"
            }, {
              default: _withCtx(() => [
                _createTextVNode(" Registrarme ")
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_4, [
            _hoisted_5,
            _createVNode(_component_router_link, {
              to: { name: 'Login' },
              class: "btn btn-primary px-4 py-2",
              tag: "button"
            }, {
              default: _withCtx(() => [
                _createTextVNode(" Iniciar sesión ")
              ]),
              _: 1
            })
          ])
        ], 64))
      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          (_unref(getters).isLogin && !_unref(state).authUser?.fidelizado)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _createElementVNode("h3", _hoisted_6, [
                  _createTextVNode(" Sección exclusiva para miembros verificados de "),
                  _createElementVNode("span", _hoisted_7, _toDisplayString(props.nombreEvento), 1)
                ]),
                _createElementVNode("p", null, [
                  _createTextVNode(" Para ser miembro es necesario que verifiquemos que sos titular de un "),
                  _createElementVNode("span", _hoisted_8, _toDisplayString(props.marca), 1),
                  _createTextVNode(" . ")
                ]),
                _hoisted_9,
                _createElementVNode("p", null, [
                  _createTextVNode(" Si aun no cargaraste tu/s "),
                  _createElementVNode("span", _hoisted_10, _toDisplayString(props.marca), 1),
                  _createTextVNode(", podes hacerlo desde el siguiente botón. ")
                ]),
                _createVNode(_component_router_link, {
                  to: { name: 'MiCuenta' },
                  class: "btn btn-primary px-4 py-2",
                  tag: "button"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(" Registrar vehículo/s ")
                  ]),
                  _: 1
                })
              ], 64))
            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                _createElementVNode("h3", _hoisted_11, [
                  _createTextVNode(" Contenido exclusivo para miembros "),
                  _createElementVNode("span", _hoisted_12, _toDisplayString(props.marca), 1)
                ]),
                _hoisted_13,
                _createVNode(_component_router_link, {
                  to: { name: 'Register' },
                  class: "btn btn-primary px-4 py-2",
                  tag: "button"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(" Quiero ser miembro ")
                  ]),
                  _: 1
                })
              ], 64))
        ], 64))
  ]))
}
}

})